import { memo } from "react";
import books_pdf from "../../Assets/Images/Books PDf.png";
import grade_1_12 from "../../Assets/Images/Grade 1 -12.png";

const EXPLORE_HREF = "/courses?grade=1&category=-1";

const FeatureCard = ({
  image,
  alt,
  title,
}: {
  image: string;
  alt: string;
  title: string;
}) => (
  <div className="card border-0 shadow div_br d-flex flex-column justify-content-center h-315px align-items-center">
    <div className="w-100 text-center my-4">
      <img src={image} alt={alt} className="w-125" />
    </div>
    <div className="w-100 text-center">
      <p className="fw-bold">{title}</p>
    </div>
    <div className="w-100 text-center mb-4">
      <a
        href={EXPLORE_HREF}
        className="btn btn-sm py-2 px-5 btn-br text-center _hover bg-success text-white"
      >
        <span className="ms-2 fw-bold"> Explore More</span>
      </a>
    </div>
  </div>
);

const HighlightedFeatures = () => (
  <div className="w-100 my-5 py-5">
    <div className="container-xxl p-0">
      <div className="row mx-0">
        <div className="col-12 col-md-8 mx-md-auto m-0 text-start text-md-center">
          <h5 className="fw-bold">Highlighted Features</h5>
          <p className="text-break fw-light">
            You can now avail Free Access to all Classes and Premium Content for
            Grades 1-12.
          </p>
        </div>
      </div>
      <div className="row mx-0 mt-5">
        <div className="col-12 col-sm-5 col-md-4 col-lg-3 my-3 ms-auto">
          <FeatureCard image={books_pdf} alt="PDF" title="Book’s & Note’s PDF" />
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-3 mt-3 me-auto ms-lg-5">
          <FeatureCard
            image={grade_1_12}
            alt="Grade"
            title="Grade Selection from 1 - 12"
          />
        </div>
      </div>
    </div>
  </div>
);

export default memo(HighlightedFeatures);
